import useMutationApi from 'src/api/useMutationApi';

interface DeleteCustomerProductBody {
  customerProductId: string;
}

const useDeleteCustomerProduct = (onSuccess?: () => void) => {
  return useMutationApi<DeleteCustomerProductBody, void>({
    endpoint: 'accounts-receivable/customer-products',
    method: 'DELETE',
    options: {
      onSuccess,
    },
    showSuccessToast: true,
  });
};

export default useDeleteCustomerProduct;
